import React from 'react';
import Alert from '@visa/vds/alert';
import AlertIcon from '@visa/vds/alert-icon';
import AlertLabel from '@visa/vds/alert-label';
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import Icon from '@visa/vds/icon';

const MCSAlertSuccess = (props) => {

    return(
            props.successMessage !== "" && props.showAlert && 
            <Alert 
            autoCloseTimeout={10000}
            id="alert-default-success" 
            show={props.showAlert} 
            position="relative" 
            alertType="success" 
            autoClose={true}
            style={{ marginTop: 65 }}
            onBeforeClose={()=>{props.toggleShowSuccessAlert(false); props.setSuccessMessage("")}}>
            <Grid>
                <Row>
                <Col>
                    <AlertIcon>
                    <Icon name="success" resolution="low" />
                    </AlertIcon>
                    <AlertLabel>{props.successMessage}</AlertLabel>
                </Col>
                </Row>
            </Grid>
            </Alert>
        
    )
}

export default MCSAlertSuccess;